<h2>{{ title }}</h2>
<p class="text-base">{{ body }}</p>
<!-- action button -->
<div class="hrz-end gap-1">
    <button *ngIf="cancelButtonLabel" mat-flat-button  class="text-button" (click)="cancelButton()">{{ cancelButtonLabel }}</button>
    <button *ngIf="confirmButtonLabel" mat-button (click)="confirmButton()" class="flat-button">{{ confirmButtonLabel }}</button>
</div>
